import useSystemStore from 'parts/systemStore/systemStore'
import { useEffect } from 'react'
import schoolRequests from 'parts/requests/school/schoolRequest'

export function hasStoredAccessToken(): boolean {
	return Boolean(localStorage.getItem('token'))
}

/**
 * Returns the user status in the store:
 * loading — session restore is in progress
 * notExists — guest (no user)
 * exists — user is in the store
 */
export function useGetUserStatusInStore() {
	const user = useSystemStore((store) => store.user)

	if (user === undefined) {
		if (!hasStoredAccessToken()) {
			return 'notExists'
		}
		return 'loading'
	}

	return user ? 'exists' : 'notExists'
}

/** Скачивает данные школы и ставит в Хранилище */
export function useSetSchool() {
	useEffect(function () {
		prepareSchool()
	}, [])
}

async function prepareSchool() {
	// Получает с сервера данные текущей школы и помещает в Хранилище
	const school = await getSchool()

	if (school) {
		const { updateStore } = useSystemStore.getState()
		updateStore({ school })
	}
}

/** Получает с сервера данные школы */
async function getSchool() {
	// Отправить запрос и получить ответ
	const response = await schoolRequests.getCurrentSchool()

	if (response.data) {
		return response.data
	}
}
